import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import { formatAmount, fractionToPercent } from 'helpers/helpers';
import Info from 'components/Tooltip/Info';

import { DevelopmentStore } from 'stores/account/developmentStore';
import { useDevelopmentStyles } from 'components/Bucket/styles'; //
import { AccountDetailData } from 'stores/account/model';

interface Props {
  detail: AccountDetailData;
  store: DevelopmentStore;
  periods: { value: string; label: string }[];
}

const DevelopmentOverview: React.FC<Props> = ({ store, detail, periods }) => {
  const { t } = useTranslation();
  const devClasses = useDevelopmentStyles();

  const profit =
    store && detail
      ? store.activeBucket === 0
        ? detail.profit
        : { value: store.profitValue !== null ? store.profitValue : 0 }
      : { value: 0 };

  return (
    <Grid container item xs={12} spacing={0} className={devClasses.info}>
      <Grid container item xs={12} sm={12} md={9} lg={9} xl={10} spacing={0}>
        <Grid container item xs={12} sm={12} md={4} spacing={0}>
          <Grid item xs={12} className={devClasses.title}>
            {t('accountDetail_graph_current')}
            {store.activeBucket > 0 && t('accountDetail_graph_portfolioValue')}
            <span>
              {store.activeBucket === 0 && (
                <>
                  <br />
                  {t('accountDetail_graph_current_all')}
                </>
              )}
            </span>
          </Grid>
          <Grid item xs={12} className="value">
            {store.balance !== null && <strong>{formatAmount({ value: store.balance }, detail.currency)}</strong>}
          </Grid>
        </Grid>

        <Grid container item xs={12} sm={12} md={4} spacing={0}>
          <Grid item xs={12} className={devClasses.title}>
            {t('accountDetail_graph_invested')}
          </Grid>
          <Grid item xs={12} className="value">
            <strong className="investments">
              {store.investments !== null && formatAmount({ value: store.investments }, detail.currency)}
            </strong>
          </Grid>
        </Grid>

        <Grid container item xs={12} sm={12} md={4} spacing={0}>
          <Grid item xs={12} className={devClasses.title}>
            {t('accountDetail_graph_profit')}
            {store.activeBucket > 0 && t('accountDetail_graph_portfolioValue')}
            <span>
              {store.activeBucket === 0 && (
                <>
                  <br />
                  {t('accountDetail_graph_profit_all')}
                </>
              )}
            </span>
          </Grid>
          <Grid item xs={12} className="value">
            <strong className={profit.value >= 0 ? 'positive' : 'negative'}>
              {formatAmount(profit, detail.currency)}
            </strong>
          </Grid>
        </Grid>
      </Grid>

      {store.yearlyProfit !== null &&
        store.yearlyProfit !== undefined && ( //EDS-4671 -> 2.2.6 && !store.percentage
          <Grid container item xs={12} sm={12} md={3} lg={3} xl={2} spacing={0} className="yearlyProfit">
            <Grid item xs={12} className={devClasses.title}>
              {t('accountDetail_graph_avgProfit')}
              {store.activeBucket > 0 && t('accountDetail_graph_portfolioValue')}
              <span>
                {store.activeBucket === 0 && (
                  <>
                    <br />
                    {t('accountDetail_graph_profit_all')}
                  </>
                )}
              </span>
            </Grid>
            <Grid item xs={12} className="value">
              <strong className={store.yearlyProfit >= 0 ? 'positive' : 'negative'}>
                {fractionToPercent(store.yearlyProfit, 2)} <span>p. a.</span>
              </strong>
              <Info content={t('tooltip_accounts_totalProfit')} button />
            </Grid>
          </Grid>
        )}
    </Grid>
  );
};

export default React.memo(observer(DevelopmentOverview));
